import { PrimaryInfoModel } from "../../../../data-model/primaryInfoCoverage";

interface PrimaryInfoProps {
  data: PrimaryInfoModel;
}

const PrimaryInfo = (props: PrimaryInfoProps) => {
  return (
    <>
      {props.data.text !== "N/A" ? (
        <>
          <div className="primary-info--container flex gap-2">
            <div className="primary-info--header flex-1 truncate text-small font-regular text-primaryGray-3">
              {props.data.header}
            </div>
            <div className="supporting-text text-small font-semibold text-primaryGray-1">
              :
            </div>
            <div className="primary-info--content flex flex-1 items-center gap-1 overflow-hidden text-small font-semibold text-primaryGray-1">
              {props.data.icon && (
                <>
                  <div className="primary-info--content-left">
                    {props.data.icon}
                  </div>
                </>
              )}
              <div
                className="primary-info--content-middle flex-1 truncate"
                style={{ color: props.data.textColor }}
              >
                {props.data.text}
              </div>
              {props.data.iconRight && (
                <>
                  <div className="primary-info--content-right">
                    {props.data.iconRight}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default PrimaryInfo;
